import { cn } from "@babybjorn/ui";
import type { FC } from "react";
import Icon from "../../../general/Icon";
import ImageContainer from "../../../general/ImageContainers";
import type { ComparisonItemProps } from "../ComparisonItem/ComparisonItem";
import * as s from "./ComparisonProductCard.module.scss";

type ComparisonProductCardProps = {
	image: { alt: string; src: string };
	index: number;
	items: ComparisonItemProps[];
	onChange: (index: number, uid: string) => void;
	openDrawer: string | null;
	setOpenDrawer: (uid: string | null) => void;
	uid: string;
	productName: string;
	rating?: string;
};

const ComparisonProductCard: FC<ComparisonProductCardProps> = ({
	image,
	index,
	items,
	onChange,
	openDrawer,
	setOpenDrawer,
	uid,
	productName,
	rating,
}) => {
	const clickHandler = (index: number, uid: string) => {
		onChange(index, uid);
		setOpenDrawer(null);
	};

	const openHandler = (uid: string) => {
		if (openDrawer === uid) {
			setOpenDrawer(null);
		} else {
			setOpenDrawer(uid);
		}
	};

	return (
		<div className={s.container}>
			<div className={s.wrapper}>
				{rating && (
					<span className={s.rating}>
						<Icon icon="star-filled" className={s.icon} />
						<p>{rating}</p>
					</span>
				)}
				<div className={s.imageWrapper}>
					<ImageContainer
						alt={image.alt}
						imgSrc={image.src}
						ratio="portrait"
						width={138}
						className={s.image}
						loading="eager"
						hidePlaceholder
					/>
				</div>
				<div className={s.dropdown}>
					{items.length > 2 ? (
						<button onClick={() => openHandler(uid)}>
							<span>{productName}</span>
							<Icon icon="arrow-down" />
						</button>
					) : (
						<h3>{productName}</h3>
					)}
					<div className={cn(s.select, { [s.close]: openDrawer !== uid })}>
						{items
							.filter((i) => i.uid !== uid)
							.map((item) => (
								<button
									key={item.uid}
									onClick={() => clickHandler(index, item.uid)}
								>
									{item.productName}
								</button>
							))}
					</div>
				</div>
				<h3 className={s.productName}>{productName}</h3>
			</div>
		</div>
	);
};
export default ComparisonProductCard;
